import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ItemEntity } from './item.entity';
import { LocationEntity } from './location.entity';

@Index('location_item_location_id_item_id_uindex', ['locationId', 'itemId'], {
	unique: true,
})
@Entity('location_item')
export class LocationItemEntity extends BaseEntity {
	@Column('int', {
		name: 'fk_location__id',
		unsigned: true,
		nullable: false,
	})
	public locationId!: number;

	@Column('int', {
		name: 'fk_item__id',
		unsigned: true,
		nullable: false,
	})
	public itemId!: number;

	/**
	 * Current stock level at this (location, item). For sensor-managed
	 * pairs, computed at sensor ingestion time from the latest fill % ×
	 * `capacity`; treated as an estimate. For non-sensor locations,
	 * manually maintained via `InventoryService`.
	 */
	@Column('int', { name: 'quantity', nullable: true })
	public quantity!: number | null;

	/**
	 * Per-(location, item) zone capacity — how many units of this item
	 * fit in the zone of this location that's monitored by its sensors.
	 * For example, the 7lb-bag zone of merchandiser 1 holds N bags.
	 * Used by the sensor-driven order generation: refillQty =
	 * `capacity - round(fillPct * capacity)`.
	 */
	@Column('int', { name: 'capacity', unsigned: true, nullable: true })
	public capacity!: number | null;

	@ManyToOne(() => LocationEntity, (location) => location.locationItems)
	@JoinColumn({ name: 'fk_location__id' })
	public fkLocation!: LocationEntity;

	@ManyToOne(() => ItemEntity)
	@JoinColumn({ name: 'fk_item__id' })
	public fkItem!: ItemEntity;
}
